import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import * as actions from "../store/actions/auth";
import { connect } from "react-redux";
import { ThemeProvider } from "@material-ui/styles";
import saurav from "../components/saurav/index";
import MuiTheme from "../theme";

// Layout Blueprints

import { LeftSidebar, PresentationLayout } from "../main";

// Example Pages

import Setting from "../pages/Admin/generalsetting/index";
import RouteMiddleware from "./middleware";
import Loading from "../components/Loading/index";
import TraineeRegistrationForm from "../components/TraineeRegistrationForm";
import WelcomePage from "../components/WelcomePage";
import EmailTemplate from "../pages/Admin/EmailTemplate";

const DashboardDefault = lazy(() => import("../pages/Admin/Dashboard"));
const LogInPage = lazy(() => import("../pages/Admin/LoginPage"));
// const trainee = lazy(() => import("../pages/Admin/trainee/index"));
const trainee_approval = lazy(() => import("../pages/Admin/trainee/approval"));
const trainee_Form = lazy(() => import("../pages/Admin/trainee/created_edit"));
const traning = lazy(() => import("../pages/Admin/traning/index"));
const registrationTraining = lazy(() =>
  import("../pages/Admin/traning/registrations")
);
const report = lazy(() => import("../pages/Admin/report/index"));
const traningtype = lazy(() => import("../pages/Admin/traningtype/index"));
const trainer = lazy(() => import("../pages/Admin/trainer/index"));
const costManagement = lazy(() =>
  import("../pages/Admin/costManagement/index")
);
const traningDetail = lazy(() =>
  import("../pages/Admin/traning/traineeDetail")
);
const sessionDetail = lazy(() =>
  import("../pages/Admin/traning/sessionDetail")
);
const sessionAttendanceDetail = lazy(() =>
  import("../pages/Admin/traning/sessionAttendanceDetail")
);
const traning_Form = lazy(() => import("../pages/Admin/traning/created_edit"));
const traningtype_Form = lazy(() =>
  import("../pages/Admin/traningtype/created_edit")
);
const trainer_Form = lazy(() => import("../pages/Admin/trainer/created_edit"));
const costManagement_Form = lazy(() =>
  import("../pages/Admin/costManagement/created_edit")
);
const session_form = lazy(() => import("../pages/Admin/session/created_edit"));
const userRoleManagement = lazy(() =>
  import("../pages/Admin/UserManagement/UserRole/index")
);
const userManagement = lazy(() =>
  import("../pages/Admin/UserManagement/User/index")
);
const userRoleCreateEdit = lazy(() =>
  import("../pages/Admin/UserManagement/UserRole/create_edit")
);
const userCreateEdit = lazy(() =>
  import("../pages/Admin/UserManagement/User/create_edit")
);

const Routes = (props) => {
  const location = useLocation();

  const pageVariants = {
    initial: {
      opacity: 0,
      scale: 0.99,
    },
    in: {
      opacity: 1,
      scale: 1,
    },
    out: {
      opacity: 0,
      scale: 1.01,
    },
  };

  const pageTransition = {
    type: "tween",
    ease: "anticipate",
    duration: 0.4,
  };

  return (
    <ThemeProvider theme={MuiTheme}>
      <AnimatePresence>
        <Suspense fallback={<Loading />}>
          <Switch>
            {!props.isAuthenticated ? (
              <Redirect exact from="/" to="/welcome" />
            ) : (
              <Redirect exact from="/" to="/admin/DashboardDefault" />
            )}

            {!props.isAuthenticated ? (
              <Route
                path={[
                  "/auth/login",
                  "/auth/signup",
                  "/saurav",
                  "/welcome",
                  "/number",
                  "/rd/demo",
                  "/trainee/register",
                ]}
              >
                <PresentationLayout>
                  <Switch location={location} key={location.pathname}>
                    <motion.div
                      initial="initial"
                      animate="in"
                      exit="out"
                      variants={pageVariants}
                      transition={pageTransition}
                    >
                      <Route path="/auth/login" component={LogInPage} />
                      <Route path="/saurav" component={saurav} />
                      <Route
                        path="/rd/demo"
                        component={lazy(() =>
                          import("../components/TraineeRegistrationForm/demo")
                        )}
                      />
                      <Route path="/welcome" component={WelcomePage} />
                      <Route
                        path="/trainee/register"
                        component={TraineeRegistrationForm}
                      />
                    </motion.div>
                  </Switch>
                </PresentationLayout>
              </Route>
            ) : (
              <Redirect exact from="/auth/login" to="/admin/DashboardDefault" />
            )}

            {props.isAuthenticated ? (
              <Route
                path={[
                  "/admin/DashboardDefault",
                  "/admin/Setting",
                  "/admin/trainee",
                  "/admin/trainee-approval",
                  "/admin/training/:trainingId/trainee-create",
                  "/admin/training/:trainingId/session-create",
                  "/admin/training/:trainingId/trainee-edit/:id",
                  "/admin/training/:trainingId/session-edit/:id",
                  "/admin/training/:trainingId/session-attendance/:id",
                  "/admin/trainings",
                  "/admin/registrationTraining",
                  "/admin/trainings-type",
                  "/admin/training-type-create",
                  "/admin/training-type-edit/:id",
                  "/admin/training-detail/:id",
                  "/admin/training-session-detail/:id",
                  "/admin/training-create",
                  "/admin/training-edit/:id",
                  "/admin/trainer",
                  "/admin/trainer-create",
                  "/admin/trainer-edit/:id",
                  "/admin/costManagement",
                  "/admin/costManagement-create",
                  "/admin/costManagement-edit/:id",
                  "/admin/users",
                  "/admin/user/create",
                  "/admin/user-edit/:id",
                  "/admin/roles",
                  "/admin/role-edit/:id",
                  "/admin/role/create",
                  "/admin/email/template",
                  "/admin/report",
                ]}
              >
                <LeftSidebar>
                  <Switch location={location} key={location.pathname}>
                    <motion.div
                      initial="initial"
                      animate="in"
                      exit="out"
                      variants={pageVariants}
                      transition={pageTransition}
                    >
                      <RouteMiddleware
                        name="dashboard-list"
                        key="dashboard-list"
                        exact
                        path="/admin/DashboardDefault"
                        render={() => <DashboardDefault />}
                      />
                      <RouteMiddleware
                        path="/admin/Setting"
                        name="setting-list"
                        key="setting"
                        component={Setting}
                      />

                      {/*<RouteMiddleware*/}
                      {/*  path='/admin/trainee'*/}
                      {/*  name="setting-edit"*/}
                      {/*  key="trainee"*/}
                      {/*  component={trainee} />*/}
                      <RouteMiddleware
                        path="/admin/trainings"
                        name="training-list"
                        key="training-list"
                        component={traning}
                      />

                      <RouteMiddleware
                        path="/admin/registrationTraining"
                        name="registrationTraining-list"
                        key="registrationTraining-list"
                        component={registrationTraining}
                      />

                      <RouteMiddleware
                        path="/admin/report"
                        name="report-list"
                        key="report-list"
                        component={report}
                      />

                      <RouteMiddleware
                        path="/admin/trainings-type"
                        name="training-type-list"
                        key="training-type-list"
                        component={traningtype}
                      />

                      <RouteMiddleware
                        path="/admin/trainee-approval"
                        name="trainee-approval"
                        key="trainee-approval"
                        component={trainee_approval}
                      />
                      <RouteMiddleware
                        path="/admin/training/:trainingId/trainee-create"
                        name="training-trainee-add"
                        key="trainee-create"
                        component={trainee_Form}
                      />
                      <RouteMiddleware
                        path="/admin/training/:trainingId/session-create"
                        name="training-session-add"
                        key="session-create"
                        component={session_form}
                      />
                      <RouteMiddleware
                        path="/admin/training/:trainingId/trainee-edit/:id"
                        name="training-trainee-edit"
                        key="trainee-edit"
                        component={trainee_Form}
                      />
                      <RouteMiddleware
                        path="/admin/training/:trainingId/session-edit/:id"
                        name="training-session-edit"
                        key="session-edit"
                        component={session_form}
                      />
                      <RouteMiddleware
                        path="/admin/training/:trainingId/session-attendance/:id"
                        name="training-session-view-attendance"
                        key="session-attendance"
                        component={sessionAttendanceDetail}
                      />

                      <RouteMiddleware
                        path="/admin/training-detail/:id"
                        name="training-view-trainee"
                        key="training-detail"
                        component={traningDetail}
                      />
                      <RouteMiddleware
                        path="/admin/training-session-detail/:id"
                        name="training-view-session"
                        key="training-session-detail"
                        component={sessionDetail}
                      />

                      <RouteMiddleware
                        path="/admin/training-create"
                        name="training-add"
                        key="training-create"
                        component={traning_Form}
                      />
                      <RouteMiddleware
                        path="/admin/training-type-create"
                        name="training-type-add"
                        key="training-type-create"
                        component={traningtype_Form}
                      />

                      <RouteMiddleware
                        path="/admin/training-edit/:id"
                        name="training-edit"
                        key="training-edit"
                        component={traning_Form}
                      />
                      <RouteMiddleware
                        path="/admin/training-type-edit/:id"
                        name="training-type-edit"
                        key="training-type-edit"
                        component={traningtype_Form}
                      />

                      <RouteMiddleware
                        path="/admin/trainer"
                        name="trainer-list"
                        key="trainer"
                        component={trainer}
                      />
                      <RouteMiddleware
                        path="/admin/trainer-create"
                        name="trainer-create"
                        key="trainer-create"
                        component={trainer_Form}
                      />
                      <RouteMiddleware
                        path="/admin/trainer-edit/:id"
                        name="trainer-edit"
                        key="trainer-edit"
                        component={trainer_Form}
                      />

                      <RouteMiddleware
                        path="/admin/costManagement"
                        name="cost-management-list"
                        key="cost-management"
                        component={costManagement}
                      />
                      <RouteMiddleware
                        path="/admin/costManagement-create"
                        name="setting-edit"
                        key="cost-management-edit"
                        component={costManagement_Form}
                      />
                      <RouteMiddleware
                        path="/admin/costManagement-edit/:id"
                        name="setting-edit"
                        key="cost-management-edit-index"
                        component={costManagement_Form}
                      />
                      <RouteMiddleware
                        path="/admin/email/template"
                        name="email-template-list"
                        key="email-template"
                        component={EmailTemplate}
                      />
                      <RouteMiddleware
                        path="/admin/roles"
                        name="role-list"
                        key="user-role-management"
                        component={userRoleManagement}
                      />
                      <RouteMiddleware
                        path="/admin/role/create"
                        name="role-create"
                        key="user-role-management-create"
                        component={userRoleCreateEdit}
                      />
                      <RouteMiddleware
                        path="/admin/role-edit/:id"
                        name="role-edit"
                        key="user-role-management-edilt"
                        component={userRoleCreateEdit}
                      />
                      <RouteMiddleware
                        path="/admin/users"
                        name="user-list"
                        key="user-role-management-list"
                        component={userManagement}
                      />
                      <RouteMiddleware
                        path="/admin/user/create"
                        name="user-create"
                        key="user-role-management-user-create"
                        component={userCreateEdit}
                      />
                      <RouteMiddleware
                        path="/admin/user-edit/:id"
                        name="user-edit"
                        key="user-role-management-user-edit"
                        component={userCreateEdit}
                      />
                    </motion.div>
                  </Switch>
                </LeftSidebar>
              </Route>
            ) : (
              <Redirect exact to="/welcome" />
            )}
          </Switch>
        </Suspense>
      </AnimatePresence>
    </ThemeProvider>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
    autherror: state.auth.error,
    bookerror: state.book.error,
    permissions:
      typeof state.auth["user"] != "undefined" &&
      typeof state.auth.user["permissions"] != "undefined"
        ? state.auth.user.permissions
        : [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
